import type { IconData } from '@stacksjs/iconify-core'

export const circle: IconData = {
  "body": "<circle cx=\"12\" cy=\"12\" r=\"10\" fill=\"currentColor\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default circle
